export const GET_USERS = "GET_USERS";
export const GET_AD_USER = "GET_AD_USER";
export const GET_AD_SHI_ID = "GET_AD_SHI_ID";
export const CREATE_OR_UPDATE_USER = "CREATE_OR_UPDATE_USER";
export const SYNC_USERS = "SYNC_USERS";

export const GET_ROLES = "GET_ROLES";
export const CREATE_OR_UPDATE_ROLE = "CREATE_OR_UPDATE_ROLE";

export const GET_PERMISSIONS = "GET_PERMISSIONS";
